/**
 * RFQ Drawer & Item Manager — v3 (XSS-safe)
 * Fixes: esc() helper for innerHTML, safe attribute encoding
 */
(function () {
  var KEY = 'rfq_items';
  var C = window.__RFQ_CONFIG__ || {};

  try {
    C = JSON.parse(document.getElementById('rfq-init-data').textContent);
  } catch (e) {}

  var dialog = document.getElementById('rfq-drawer');
  if (dialog) dialog.setAttribute('aria-modal', 'true');
  var list = document.getElementById('rfq-items-list');
  var empty = document.getElementById('rfq-empty');
  var count = document.getElementById('rfq-count');
  var footer = dialog ? dialog.querySelector('.rfq-drawer__footer') : null;
  var items = [];
  var syncing = false;

  /* ── XSS helper ────────────────────────────────── */
  function esc(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str || ''));
    return d.innerHTML;
  }

  /* ── localStorage ──────────────────────────────── */
  function load() {
    try {
      items = JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      items = [];
    }
    return items;
  }

  function save(d) {
    if (d) items = d;
    localStorage.setItem(KEY, JSON.stringify(items));
    /* Notify same-tab listeners (storage event only fires cross-tab) */
    window.dispatchEvent(new CustomEvent('rfq:updated', { detail: { count: items.length } }));
  }

  /* ── Server sync ───────────────────────────────── */
  var SYNC_URL = (C.routes && C.routes.sync) || '/apps/rfq';
  var canSync = !!(C.customer_logged_in && C.customer_id);

  function syncFromServer() {
    if (!canSync || syncing) return Promise.resolve();
    syncing = true;
    return fetch(SYNC_URL + '/state', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        syncing = false;
        if (d && d.ok && d.items) {
          var local = load();
          if (local.length === 0 && d.items.length > 0) {
            save(d.items);
            render();
          } else if (local.length > 0 && d.items.length === 0) {
            syncToServer();
          } else if (d.items.length > 0) {
            var merged = mergeItems(d.items, local);
            save(merged);
            render();
            syncToServer();
          }
        }
      })
      .catch(function (e) {
        syncing = false;
        console.warn('RFQ sync error:', e);
      });
  }

  function syncToServer() {
    if (!canSync || syncing) return;
    syncing = true;
    fetch(SYNC_URL + '/save', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: load() })
    })
      .then(function () { syncing = false; })
      .catch(function (e) {
        syncing = false;
        console.warn('RFQ save error:', e);
      });
  }

  function mergeItems(server, local) {
    var map = {};
    server.forEach(function (it) { map[it.url] = it; });
    local.forEach(function (it) {
      if (map[it.url]) {
        map[it.url].qty = Math.max(map[it.url].qty, it.qty);
      } else {
        map[it.url] = it;
      }
    });
    var result = [];
    for (var k in map) result.push(map[k]);
    return result;
  }

  /* ── Debounced sync ────────────────────────────── */
  var saveTimer = null;
  function debouncedSync() {
    if (!canSync) return;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(syncToServer, 1500);
  }

  /* ── Item CRUD ─────────────────────────────────── */
  function addItem(url, title, img, variant) {
    load();
    var exists = items.find(function (i) { return i.url === url; });
    if (exists) {
      exists.qty++;
    } else {
      items.push({
        url: url,
        title: title || 'Product',
        img: img || '',
        variant: variant || '',
        qty: 1
      });
    }
    save();
    render();
    debouncedSync();
  }

  function removeItem(url) {
    load();
    items = items.filter(function (i) { return i.url !== url; });
    save();
    render();
    debouncedSync();
  }

  /* ── Render (XSS-safe) ─────────────────────────── */
  function render() {
    if (!list) return;
    load();

    if (empty) empty.style.display = items.length ? 'none' : '';
    if (footer) footer.style.display = '';
    if (count) count.textContent = items.length + ' ' + ((C.t && C.t.items_count) || 'items');

    list.innerHTML = items.map(function (it) {
      var h = '<div class="rfq-item">';
      if (it.img) {
        h += '<img src="' + esc(it.img) + '" width="60" height="60" loading="lazy" alt="">';
      }
      h += '<div class="rfq-item__info">';
      h += '<strong>' + esc(it.title) + '</strong>';
      h += '<label>' + esc((C.t && C.t.qty) || 'Qty') + ': ';
      h += '<input type="number" min="1" value="' + (parseInt(it.qty) || 1) + '" data-rfq-qty="' + esc(it.url) + '">';
      h += '</label></div>';
      h += '<button type="button" class="rfq-item__rm" data-rfq-rm="' + esc(it.url) + '">&times;</button>';
      h += '</div>';
      return h;
    }).join('');

    list.querySelectorAll('[data-rfq-rm]').forEach(function (b) {
      b.addEventListener('click', function () {
        removeItem(b.dataset.rfqRm);
      });
    });

    list.querySelectorAll('[data-rfq-qty]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        load();
        var it = items.find(function (i) { return i.url === inp.dataset.rfqQty; });
        if (it) {
          it.qty = parseInt(inp.value) || 1;
          save();
          debouncedSync();
        }
      });
    });
  }

  /* ── Click delegation for [data-rfq-button] ────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rfq-button]');
    if (!btn) return;
    e.preventDefault();

    var url = btn.dataset.productUrl || window.location.pathname;
    var sec = btn.closest('.product') || btn.closest('[class*="product-info"]') || document;

    var tEl = sec.querySelector('h1,.product-title,.product-info__title');
    if (!tEl) tEl = document.querySelector('h1.product-title,h1.product-info__title,.product-info__title,h1');

    var imgEl = sec.querySelector('.product-gallery img,img[src*="/cdn/shop/"]');
    if (!imgEl) imgEl = document.querySelector('.product-gallery img,.product-gallery__image img,.product__media img,img[src*="/cdn/shop/"]');

    var vEl = sec.querySelector('[name="id"]');
    if (!vEl) vEl = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var variant = vEl ? vEl.value : '';

    addItem(url, tEl ? tEl.textContent.trim() : 'Product', imgEl ? imgEl.src : '', variant);
    if (dialog) dialog.showModal();
  });

  /* ── Dialog close handlers ─────────────────────── */
  if (dialog) {
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
    dialog.querySelectorAll('[data-rfq-close]').forEach(function (b) {
      b.addEventListener('click', function () { dialog.close(); });
    });
  }

  /* ── Init ───────────────────────────────────────── */
  render();
  if (canSync) syncFromServer();

  window.__RFQ__ = {
    getItems: load,
    addItem: addItem,
    removeItem: removeItem,
    render: render,
    sync: syncFromServer
  };
})();